import { DescriptorProps } from '../constnats/descriptor';
import { ReportField } from '../constnats/reportConstants';

const REQUIRED_DESCRIPTORS_MAP = {
    [ReportField.YEAR]: 'Year',
    [ReportField.PERIOD]: 'Period',
    [ReportField.TYPE]: 'Filling Type',
    [ReportField.REPORT_TYPE]: 'Report Type',
};

export function reportsChangesToMatrix(
    changedReports: any[],
    affectedFieldsIds: Set<string>,
    dynamicFlatDescriptors: any[]
) {
    // Descriptor ID => Changes
    const allChangesMatrix: Record<string, any[]> = {};

    for (const id of Object.keys(REQUIRED_DESCRIPTORS_MAP)) {
        allChangesMatrix[id] = [REQUIRED_DESCRIPTORS_MAP[id]];
    }

    for (const descriptorId of affectedFieldsIds) {
        allChangesMatrix[descriptorId] = [];
    }

    for (const changedReport of changedReports) {
        for (const id of Object.keys(REQUIRED_DESCRIPTORS_MAP)) {
            allChangesMatrix[id].push(changedReport.updatedReport[id]);
        }

        for (const descriptorId of affectedFieldsIds) {
            const change = changedReport.changes[descriptorId];

            allChangesMatrix[descriptorId].push(change || null);
        }
    }

    const rows = [];
    for (const id of Object.keys(REQUIRED_DESCRIPTORS_MAP)) {
        rows.push({
            descriptorId: id,
            dynamic: false,
            cells: [...allChangesMatrix[id]],
        });
    }

    for (const descriptor of dynamicFlatDescriptors) {
        const descriptorId = descriptor.id;
        if (affectedFieldsIds.has(descriptorId)) {
            rows.push({
                descriptorId: descriptorId,
                dynamic: descriptor[DescriptorProps.DYNAMIC],
                cells: [descriptor.label, ...allChangesMatrix[descriptorId]],
            });
        }
    }

    return rows;
}
